import { configureStore } from '@reduxjs/toolkit'
import blogSlice from './blogData'
import caseStudySlice from './userstoriesData';

const store = configureStore({
    reducer:{blogs:blogSlice.reducer, casestudy:caseStudySlice.reducer}
})

export default store;